import { HttpErrorResponse } from '@angular/common/http';

// Shared, actionable error text for a failed policy-document / certificate open.
// With an emitted policy the document exists in the backend, so a failed open is
// almost always transitory —apiserver cold start, the PDF still rendering, client
// network— and the seller must know whether to retry, wait, or report it with the
// policy number. Used by the sale wizard (payment step) and the sell report so
// both surfaces give the same guidance.
//
// Pure function (no component state): pass the policy number for the "(póliza X)"
// hint; omit it when there is none.
export function describeDocumentError(error: unknown, policyNumber?: string): string {
  const poliza = (policyNumber || '').trim();
  const ref = poliza ? ` (póliza ${poliza})` : '';

  if (error instanceof HttpErrorResponse) {
    switch (true) {
      case error.status === 0:
        // Sin respuesta: red del cliente caída o petición cortada.
        return 'No hay conexión con el servidor. Revisa tu internet e inténtalo de nuevo.';
      case error.status === 401 || error.status === 403:
        return 'Tu sesión expiró. Vuelve a iniciar sesión y abre el documento otra vez.';
      case error.status === 404:
        return `El documento aún no está disponible${ref}. Espera unos segundos e inténtalo de nuevo.`;
      case error.status === 408 || error.status === 429 || error.status === 503 || error.status === 504:
        // Cold start del App Engine (min_instances:0) o backend ocupado:
        // el documento existe, solo tardó más de la cuenta.
        return `El servidor tardó en responder${ref}. Inténtalo de nuevo en un momento.`;
      case error.status >= 500:
        // El certificado puede estar generándose todavía justo tras emitir.
        return `El documento se está generando${ref}. Espera unos segundos e inténtalo de nuevo; si persiste, repórtalo con el número de póliza.`;
      default:
        return `No se pudo abrir el documento${ref} (error ${error.status}). Inténtalo de nuevo.`;
    }
  }

  // Error no-HTTP (p.ej. ventana emergente bloqueada o fallo al parsear el PDF).
  return `No se pudo abrir el documento${ref}. Habilita las ventanas emergentes e inténtalo de nuevo.`;
}
